import {BillingAddress} from '@domain/model/Account/Address/domain/model/BillingAddress/BillingAddress';
import {BillingAddressRepository} from '@domain/model/Account/Address/domain/model/BillingAddress/BillingAddressRepository';

const GetBillingAddress =
  (billingAddressRepository: BillingAddressRepository): (() => Promise<BillingAddress | Record<string, never>>) =>
  (): Promise<BillingAddress | Record<string, never>> => {
    return billingAddressRepository.getBillingAddress();
  };

export {GetBillingAddress};
